import styled, { css } from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

const DateInputStyled = styled.div`
  .MuiInput-underline:before,
  .MuiInput-underline:after {
    display: none;
  }

  .MuiFormControl-marginNormal {
    margin: 0;
  }

  .MuiInputAdornment-positionEnd {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }

  input {
    /* Como los inputs del tema: 40 px, borde de 1,5 px en gris, radio 8 */
    height: 40px;
    background: ${color.background.default};
    border: 1.5px solid ${color.border.default};
    box-sizing: border-box;
    border-radius: 8px;
    padding: 0 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${color.text.primary};
    outline: none;
    width: 100%;
    appearance: none;
    cursor: pointer;
    transition: border-color 0.2s ease;

    :hover,
    :focus {
      border-color: ${props => props.theme.primary || color.brand.primary};
    }

    ::placeholder {
      color: ${color.text.disabled};
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      opacity: 1;
    }

    ${props =>
      props.fontSize === 'small' &&
      css`
        font-size: 14px;
        line-height: 18px;
        ::placeholder {
          font-size: 14px;
          line-height: 18px;
        }
      `}
  }
`

export default DateInputStyled
